/**
 * US cell number formatting — presentation only.
 *
 * THE number itself is always stored and submitted as 10 bare digits (see
 * `phoneDigits` at every call site). This module only decides how those digits
 * LOOK while they are being typed, so a customer sees "(212) 555-0134" instead
 * of a continuous string. Country is fixed to the US today, which is why the
 * "+1" sits outside the field as a static prefix rather than in the value.
 */

/** Bare digits, capped at the 10 of a US national number. */
export function phoneDigits(value: string): string {
  return value.replace(/\D/g, "").slice(0, 10);
}

/** Progressive US format: "2", "(212", "(212) 555", "(212) 555-0134". */
export function formatUsPhone(value: string): string {
  const d = phoneDigits(value);
  if (d.length === 0) return "";
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

export const isCompleteUsPhone = (value: string) => phoneDigits(value).length === 10;

/** The fixed dialling prefix rendered beside the field. */
export const US_DIAL_PREFIX = "+1";
